var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.loading)?_c('div',{style:({ textAlign: 'center', paddingTop: '75px' })},[_c('h3',[_vm._v("Loading Campaign...")])]):_c('iframe',{ref:"mailBody",staticClass:"mail-body",attrs:{"width":"100%","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }